import { app } from '../../../app';
import { Controller } from './sp-grecaptcha.controller';

app.component('spGrecaptcha', {
    bindings: {state: '<'},
    controller: Controller,
});



// WEBPACK FOOTER //
// ./src/portal/components/captcha/sp-grecaptcha/sp-grecaptcha.component.js